/* frontend/src/components/TranslatorSkillCard.jsx
   ------------------------------------------------------------------
   Extracted from Skills.jsx so Dashboard.jsx can render the exact same
   card (not a copy that can drift). Technical Translation is the
   confirmed next build, not a candidate — this card carries no vote
   control of any kind; voting lives on the 8 early-stage ideas in
   SkillLeaderboard.jsx instead.

   The .tt-* column-layout classes used below are declared in this file's
   own <style> tag (moved out of Skills.jsx's page-level block) so the
   card is fully self-contained regardless of which page renders it.
*/
import { useState, useEffect } from 'react';

const T = { radius: { sm: 8, md: 12, lg: 16, xl: 20, '2xl': 24 } };

const TranslatorSkillCard = ({ skill, isDark }) => {
  const [hovered, setHovered] = useState(false);
  const [cursor, setCursor] = useState(true);
  const [scrambleText, setScrambleText] = useState('API endpoint');
  const teal = skill.color_primary;

  useEffect(() => { const id = setInterval(() => setCursor((c) => !c), 530); return () => clearInterval(id); }, []);
  useEffect(() => {
    if (!hovered) { setScrambleText('API endpoint'); return; }
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%';
    const target = 'a web address';
    let frame = 0;
    const id = setInterval(() => {
      frame++;
      if (frame < 14) {
        setScrambleText(target.split('').map((c, i) => i < Math.floor(frame * target.length / 14) ? c : chars[Math.floor(Math.random() * chars.length)]).join(''));
      } else { setScrambleText(target); clearInterval(id); }
    }, 55);
    return () => clearInterval(id);
  }, [hovered]);

  const tealLight = isDark ? 'rgba(5,150,105,0.7)' : 'rgba(4,120,87,0.8)';
  const tealDim = isDark ? 'rgba(5,150,105,0.4)' : 'rgba(4,120,87,0.45)';
  const white85 = 'rgba(255,255,255,0.85)';
  const white55 = 'rgba(255,255,255,0.55)';
  const white35 = 'rgba(255,255,255,0.35)';

  const colLeft = [
    { label: 'API endpoint', plain: scrambleText },
    { label: 'OAuth 2.0 token', plain: 'a password for apps' },
    { label: 'REST webhook', plain: 'a doorbell for data' },
    { label: 'async callback', plain: 'a task that waits' },
  ];

  return (
    <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
      style={{
        background: '#0a1a12', borderRadius: T.radius['2xl'], border: '1px solid #1a3a28',
        overflow: 'hidden', position: 'relative', fontFamily: 'var(--font-mono)',
        transition: 'all 0.3s cubic-bezier(0.22,1,0.36,1)', transform: hovered ? 'translateY(-4px)' : 'none',
        boxShadow: hovered ? `0 24px 48px rgba(5,150,105,0.25), 0 0 0 1px rgba(5,150,105,0.2)` : '0 4px 16px rgba(0,0,0,0.4)',
        display: 'flex', flexDirection: 'column',
        // Fills a flex-stretched parent's full height when one is provided
        // (e.g. VoteForNextSection); a no-op otherwise, so this stays safe
        // standalone too.
        height: '100%', boxSizing: 'border-box',
      }}>
      <style>{`
        @keyframes spin { to{transform:rotate(360deg)} }
        .tt-cols { display:grid; grid-template-columns:1fr auto 1fr; gap:0; align-items:start; }
        .tt-col { min-width:0; }
        .tt-sep { display:flex; flex-direction:column; align-items:center; padding:0 10px; padding-top:24px; }
        .tt-sep-line { width:1px; flex:1; min-height:20px; }
        @media(max-width:520px){
          .tt-cols { grid-template-columns:1fr; }
          .tt-sep { flex-direction:row; padding:6px 0; padding-top:0; }
          .tt-sep-line { width:auto; height:1px; flex:1; min-height:unset; background:linear-gradient(90deg, transparent, rgba(5,150,105,0.6), transparent) !important; }
          .tt-sep span { padding:0 8px; transform:rotate(90deg); }
        }
      `}</style>

      <div style={{ background: '#0d2218', borderBottom: '1px solid #1a3a28', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ display: 'flex', gap: 7 }}>
          {['#ff5f56', '#ffbd2e', teal].map((c, i) => (
            <div key={i} style={{ width: 12, height: 12, borderRadius: '50%', background: c, boxShadow: hovered ? `0 0 8px ${c}80` : 'none', transition: 'all 0.18s ease' }} />
          ))}
        </div>
        <span style={{ flex: 1, textAlign: 'center', fontSize: 11, color: '#2a6644', letterSpacing: '0.05em' }}>castle-atlas — technical-translation</span>
      </div>

      <div style={{ padding: '14px 20px 10px', borderBottom: '1px solid #1a3a28' }}>
        <span style={{ color: teal, fontSize: 12 }}>$ </span>
        <span style={{ color: white85, fontSize: 12 }}>translate </span>
        <span style={{ color: '#fbbf24', fontSize: 12 }}>--input</span>
        <span style={{ color: white55, fontSize: 12 }}> "technical jargon"</span>
        <span style={{ color: '#fbbf24', fontSize: 12 }}> --output</span>
        <span style={{ color: white55, fontSize: 12 }}> "plain english"</span>
      </div>

      <div className="tt-cols" style={{ flex: 1, padding: '16px 20px' }}>
        <div className="tt-col">
          <div style={{ fontSize: 9, color: tealDim, fontWeight: 700, letterSpacing: '0.1em', marginBottom: 10 }}>// TECHNICAL INPUT</div>
          {colLeft.map(({ label }, i) => (
            <div key={label} style={{ padding: '7px 10px', marginBottom: 6, borderRadius: 6, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
              <span style={{ fontSize: 11, color: i === 0 ? white85 : white55, fontWeight: i === 0 ? 700 : 400 }}>{label}</span>
            </div>
          ))}
        </div>
        <div className="tt-sep">
          <div className="tt-sep-line" style={{ background: `linear-gradient(180deg, transparent, ${teal}60, transparent)` }} />
          <span style={{ color: teal, fontSize: 12, padding: '4px 0' }}>→</span>
          <div className="tt-sep-line" style={{ background: `linear-gradient(180deg, transparent, ${teal}60, transparent)` }} />
        </div>
        <div className="tt-col">
          <div style={{ fontSize: 9, color: tealDim, fontWeight: 700, letterSpacing: '0.1em', marginBottom: 10 }}>// PLAIN ENGLISH</div>
          {colLeft.map(({ label, plain }, i) => (
            <div key={label} style={{ padding: '7px 10px', marginBottom: 6, borderRadius: 6, background: `${teal}08`, border: `1px solid ${teal}20` }}>
              <span style={{ fontSize: 11, color: i === 0 ? teal : tealLight, fontWeight: i === 0 ? 700 : 400 }}>{i === 0 ? plain : colLeft[i].plain}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: '0 20px 14px', borderTop: '1px solid #1a3a28' }}>
        <div style={{ paddingTop: 12, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          {[['name', `"${skill.name}"`], ['status', '"confirmed — next in the build queue"'], ['modules', `${skill.lessons} · exercises: ${skill.exercises}`]].map(([k, v]) => (
            <div key={k} style={{ display: 'flex', gap: 6, alignItems: 'baseline' }}>
              <span style={{ color: '#2a6644', fontSize: 10 }}>{k}:</span>
              <span style={{ color: k === 'name' ? '#fbbf24' : k === 'status' ? tealLight : white55, fontSize: 10 }}>{v}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ background: '#0d2218', borderTop: '1px solid #1a3a28', padding: '12px 20px' }}>
        <div style={{ marginBottom: 8, fontSize: 10, color: white35 }}>
          <span style={{ color: teal }}>$ </span>
          status
          <span style={{ opacity: cursor ? 1 : 0, color: teal }}>_</span>
        </div>
        <div style={{
          width: '100%', minHeight: 40, boxSizing: 'border-box', padding: '10px 14px',
          background: `${teal}18`, color: teal, border: `1px solid ${teal}`,
          borderRadius: T.radius.sm, fontWeight: 700, fontSize: 12,
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
          fontFamily: 'var(--font-mono)',
        }}>
          <span style={{ color: teal }}>✓</span> confirmed next build
        </div>
      </div>
    </div>
  );
};

export default TranslatorSkillCard;
